import React from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import Navbar from "../../Components/Navbar";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import { useFormik } from "formik";
import {
  InputGroup,
  Label,
  SubmitBtn,
} from "../../Components/Styles/InputStyles";
import * as Yup from "yup";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import Loading from "../../Components/Loading";

const validationSchema = Yup.object().shape({
  mobile: Yup.string()
    .required("Please Enter Number")
    .test(
      "is-valid-mobiles",
      "Enter valid 10 digit numbers separated by commas",
      (value) => {
        if (!value) return false;

        const numbers = value.split(",");
        return numbers.every((num) => /^\d{10}$/.test(num.trim()));
      },
    ),
  templateId: Yup.string().required("Please Enter Template Id"),
});
const Broadcast = () => {
  const user = useSelector((state) => state.UserReducer.user);

  const BroadcastMessageFunction = async (values) => {
    const body = new FormData();
    body.append("mobile", values.mobile);
    body.append("templateId", values.templateId);

    return await axios.post(`${Config.apiUrl}/broadcast`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onBroadcastSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Add Broadcast successfully!");
    } else {
      toast.error(data?.data?.msg || "An Error Occurred");
    }
  };

  const onBroadcastError = (error) => {
    toast.error(error?.response?.data?.msg || "An Error Occurred");
  };

  const { isLoading: broadcastLoading, mutate: broadcastMutate } = useMutation(
    BroadcastMessageFunction,
    {
      onSuccess: onBroadcastSuccess,
      onError: onBroadcastError,
    },
  );
  const formik = useFormik({
    initialValues: {
      mobile: "",
      templateId: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const cleanedValues = {
        ...values,
        mobile: values.mobile
          .split(",")
          .map((num) => num.trim())
          .join(","),
      };

      broadcastMutate(cleanedValues);
    },
  });
  return (
    <Bg
      style={{
        backgroundImage: `url(${Images.BeamsBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "top left",
        height: "100vh",
      }}
    >
      <Navbar />

      <BoxContainer>
        {/* HEADER */}
        <div className="flex justify-between items-center">
          <div>
            <Title>Broadcast</Title>
            <Underline />
          </div>
        </div>
        <form onSubmit={formik.handleSubmit}>
          <FormWrapper>
            {/* Mobile */}
            <InputGroup>
              <Label>Mobile</Label>
              <Input
                name="mobile"
                value={formik.values.mobile}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[0-9,]*$/.test(value)) {
                    formik.setFieldValue("mobile", value);
                  }
                }}
                onBlur={formik.handleBlur}
                placeholder="Enter Mobile Number"
              />
              {formik.touched.mobile && formik.errors.mobile && (
                <ErrorText>{formik.errors.mobile}</ErrorText>
              )}
            </InputGroup>
            {/* template ID */}
            <InputGroup>
              <Label>Template ID</Label>
              <Input
                name="templateId"
                value={formik.values.templateId}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter Template ID"
              />
              {formik.touched.templateId && formik.errors.templateId && (
                <ErrorText>{formik.errors.templateId}</ErrorText>
              )}
            </InputGroup>
          </FormWrapper>

          <BtnWrapper>
            <SubmitBtn type="submit">
              {broadcastLoading ? (
                <Loading height={20} width={20} noPadding />
              ) : (
                "Send Message"
              )}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </BoxContainer>
    </Bg>
  );
};

const Title = tw.h1`text-xl text-gray-800 font-medium`;

const Input = tw.input`truncate border border-gray-300 rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600`;
const ErrorText = tw.div`text-red-500 text-sm`;
const FormWrapper = tw.div`px-1 py-4 space-y-3`;
const BtnWrapper = tw.div`w-full flex justify-center mt-8`;

export default Broadcast;





































// import React from "react";
// import tw from "tailwind-styled-components";
// import Images from "../../Images";
// import Navbar from "../../Components/Navbar";
// import {
//   Bg,
//   BoxContainer,
//   Underline,
// } from "../../Components/Styles/PageStyles";
// import { useFormik } from "formik";
// import {
//   InputGroup,
//   Label,
// } from "../../Components/Styles/InputStyles";
// import * as Yup from "yup";
// import axios from "axios";
// import Config from "../../Config";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { useMutation } from "react-query";
// import Loading from "../../Components/Loading";
// import { MdCampaign } from "react-icons/md";

// const validationSchema = Yup.object().shape({
//   mobile: Yup.string()
//     .required("Please Enter Number")
//     .test(
//       "is-valid-mobiles",
//       "Enter valid 10 digit numbers separated by commas",
//       (value) => {
//         if (!value) return false;

//         const numbers = value.split(",");
//         return numbers.every((num) => /^\d{10}$/.test(num.trim()));
//       },
//     ),
//   templateId: Yup.string().required("Please Enter Template Id"),
// });
// const Broadcast = () => {
//   const user = useSelector((state) => state.UserReducer.user);

//   const BroadcastMessageFunction = async (values) => {
//     const body = new FormData();
//     body.append("mobile", values.mobile);
//     body.append("templateId", values.templateId);

//     return await axios.post(`${Config.apiUrl}/broadcast`, body, {
//       headers: {
//         authorization: "Bearer " + user.token,
//         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//       },
//     });
//   };

//   const onBroadcastSuccess = (data) => {
//     if (data?.data?.status === "OK") {
//       toast.success(data?.data?.msg || "Add Broadcast successfully!");
//     } else {
//       toast.error(data?.data?.msg || "An Error Occurred");
//     }
//   };

//   const onBroadcastError = (error) => {
//     toast.error(error?.response?.data?.msg || "An Error Occurred");
//   };

//   const { isLoading: broadcastLoading, mutate: broadcastMutate } = useMutation(
//     BroadcastMessageFunction,
//     {
//       onSuccess: onBroadcastSuccess,
//       onError: onBroadcastError,
//     },
//   );
//   const formik = useFormik({
//     initialValues: {
//       mobile: "",
//       templateId: "",
//     },
//     validationSchema,
//     onSubmit: (values) => {
//       const cleanedValues = {
//         ...values,
//         mobile: values.mobile
//           .split(",")
//           .map((num) => num.trim())
//           .join(","),
//       };

//       broadcastMutate(cleanedValues);
//     },
//   });
//   return (
//     <Bg
//       style={{
//         backgroundImage: `url(${Images.BeamsBg})`,
//         backgroundRepeat: "no-repeat",
//         backgroundSize: "contain",
//         backgroundPosition: "top left",
//         height: "100vh",
//       }}
//     >
//       <Navbar />
// <BoxContainer className="flex justify-center items-center min-h-[80vh]">
//   <Card>
//     {/* HEADER */}
//     <Header>
//       <IconWrap>
//         <MdCampaign size={22} />
//       </IconWrap>
//       <div>
//         <Title>Broadcast Message</Title>
//         <SubText>Send messages to multiple users instantly</SubText>
//       </div>
//     </Header>

//     <form onSubmit={formik.handleSubmit}>
//       <FormWrapper>
//         {/* Mobile */}
//         <InputGroup>
//           <Label>Mobile Numbers</Label>
//           <Input
//             name="mobile"
//             value={formik.values.mobile}
//             onChange={(e) => {
//               const value = e.target.value;
//               if (/^[0-9,]*$/.test(value)) {
//                 formik.setFieldValue("mobile", value);
//               }
//             }}
//             onBlur={formik.handleBlur}
//             placeholder="9876543210, 9123456780"
//           />
//           <HintText>Use comma to add multiple numbers</HintText>
//           {formik.touched.mobile && formik.errors.mobile && (
//             <ErrorText>{formik.errors.mobile}</ErrorText>
//           )}
//         </InputGroup>

//         {/* Template ID */}
//         <InputGroup>
//           <Label>Template ID</Label>
//           <Input
//             name="templateId"
//             value={formik.values.templateId}
//             onChange={formik.handleChange}
//             onBlur={formik.handleBlur}
//             placeholder="Enter template ID"
//           />
//           {formik.touched.templateId && formik.errors.templateId && (
//             <ErrorText>{formik.errors.templateId}</ErrorText>
//           )}
//         </InputGroup>
//       </FormWrapper>

//       <BtnWrapper>
//         <SubmitBtn type="submit" disabled={broadcastLoading}>
//           {broadcastLoading ? (
//             <Loading height={20} width={20} noPadding />
//           ) : (
//             "Send Broadcast"
//           )}
//         </SubmitBtn>
//       </BtnWrapper>
//     </form>
//   </Card>
// </BoxContainer>
//     </Bg>
//   );
// };

// const Title = tw.h1`text-xl text-gray-800 font-medium`;

// const Card = tw.div`
//   w-full max-w-lg bg-white/80 backdrop-blur-md 
//   shadow-xl rounded-2xl p-6 border border-gray-200
// `;

// const Header = tw.div`
//   flex items-center gap-3 mb-6
// `;

// const IconWrap = tw.div`
//   bg-blue-100 text-blue-600 p-2 rounded-xl
// `;


// const SubText = tw.p`
//   text-sm text-gray-500
// `;

// const Input = tw.input`
//   w-full px-3 py-2 mt-1
//   border border-gray-300 rounded-lg
//   bg-white/70
//   focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
//   transition-all duration-200
// `;

// const HintText = tw.p`
//   text-xs text-gray-400 mt-1
// `;

// const ErrorText = tw.div`
//   text-red-500 text-sm mt-1
// `;

// const FormWrapper = tw.div`
//   space-y-4
// `;

// const BtnWrapper = tw.div`
//   mt-6
// `;

// const SubmitBtn = tw.button`
//   w-full py-2.5 rounded-lg text-white font-medium
//   bg-gradient-to-r from-blue-600 to-indigo-600
//   hover:from-blue-700 hover:to-indigo-700
//   transition-all duration-200
//   shadow-md hover:shadow-lg
//   active:scale-[0.98]
//   disabled:opacity-70
// `;
// export default Broadcast;

